import axios from 'axios';

const api = axios.create({
    // Altere de "https://reprobird.com.br" para "https://reprobird.com.br/api"
    baseURL: 'https://reprobird.com.br/api', 
});

export default api;